import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { CancelTokenSource } from 'axios';
import { get } from 'lodash';
import { showConfirm } from 'components/modal/showConfirm';
import apiClient, { WrappingApiClient } from 'libs/api/apiClient';
import { handleFieldError } from 'libs/api/errorHandle';
import { TSubcategory } from 'modules/learning/boardTypes';
import { CMAIN_THEMES } from 'constants/learningboard.const';
import { ENotificationType } from 'enums/base.enum';
import { Checkbox, Button, Row, Modal, Typography, Form, Input, Divider } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { FormWrapper } from 'GlobalStyles';

const EditSubcategoryModal = ({ modalState, setModalState }: any) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState();
  const [theme, setTheme] = useState('');
  const [getSubcategory, setGetSubcategory] = useState<TSubcategory[]>();
  const [rendering, setRendering] = useState(false);
  const history = useHistory();
  const { Title } = Typography;

  useEffect(() => {
    setVisible(modalState.visible);
  }, [modalState.visible]);

  const getSubcategoryList = (theme: string) => {
    return WrappingApiClient(apiClient.get(`/drill/board/subcategories?subject=${theme}`));
  };

  useEffect(() => {
    if (theme) {
      const getSubcategories = async () => {
        const { success, data } = await getSubcategoryList(theme);
        if (success) setGetSubcategory(data);
      };
      getSubcategories();
    }

    setRendering(false);
  }, [theme, rendering]);

  function handleCancel() {
    setModalState({ visible: false });
  }

  const deleteSubcategory = (id: string, cancel?: CancelTokenSource) => {
    return apiClient.delete(`/drill/board/subcategory/${id}`, {
      cancelToken: cancel?.token,
    });
  };

  async function onClickDelete(id: string) {
    try {
      await deleteSubcategory(id);

      history.push({
        state: {
          notification: {
            type: ENotificationType.Success,
            message: 'Subcategory가 삭제되었습니다.',
          },
        },
      });
    } catch (e) {
      throw e;
    } finally {
      setRendering(true);
    }
  }

  const createSubcategory = (params: any, cancel?: CancelTokenSource) => {
    return apiClient.post(`/drill/board/subcategory`, params, {
      cancelToken: cancel?.token,
    });
  };

  function onClickSubmit() {
    form.validateFields().then((value) => {
      handleSubmit(value as any);
    });
    async function handleSubmit(value: any) {
      try {
        const data: any = {
          subject: get(value, 'subject')[0],
          name: get(value, 'editSubcategory'),
        };

        createSubcategory(data);
        history.push({
          state: {
            notification: {
              type: ENotificationType.Success,
              message: 'subcategory가 생성되었습니다.',
            },
          },
        });

        setRendering(true);
      } catch (e) {
        handleFieldError(e, form);
        throw e;
      }
    }
  }

  return (
    <Modal
      visible={visible}
      centered={true}
      maskClosable={true}
      closable={true}
      footer={
        <Button type='primary' onClick={handleCancel}>
          닫기
        </Button>
      }
      width={540}
      onCancel={handleCancel}
    >
      <FormWrapper style={{ padding: '0px' }}>
        <Title level={3}>Subcategory 편집</Title>
        <Form form={form} name='설명문 주제' colon={false} className='form-normal' style={{ margin: '10px' }}>
          <Row>
            {CMAIN_THEMES.map(({ name, link }) => (
              <Form.Item name={'subject'} style={{ marginBottom: '10px' }}>
                <Checkbox.Group className='checkbox-btn'>
                  <Checkbox value={link} onClick={() => setTheme(link)}>
                    {name}
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
            ))}
            <Divider />
            {getSubcategory &&
              getSubcategory.map(({ name, id }) => (
                <Form.Item name={'subcategory'}>
                  <Checkbox.Group className='checkbox-btn'>
                    <Checkbox
                      value={name}
                      onClick={() =>
                        showConfirm(() => onClickDelete(id.toString()), 'Subcategory를 삭제하시겠습니까?')
                      }
                    >
                      {name}
                      <CloseOutlined style={{ marginLeft: '5px' }} />
                    </Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              ))}
            <Row>
              <Form.Item name='editSubcategory' className='form-item' style={{ marginRight: '10px' }}>
                <Input
                  size='large'
                  placeholder='Subject를 선택하세요.'
                  disabled={!form.getFieldValue('subject')}
                />
              </Form.Item>
              <Button className='primary' onClick={onClickSubmit}>
                추가
              </Button>
            </Row>
          </Row>
        </Form>
      </FormWrapper>
    </Modal>
  );
};

export default EditSubcategoryModal;
